<div *ngIf="fundraiser?.raised?.backers" class="supporters">
  <img loading="lazy" class="donors-img" [attr.data-src]="supporterImg" alt="all supporters" />
  <span>{{fundraiser?.raised?.backers | inrFormat:'inr'}} supporters</span>
</div>